import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const unassignProductUserEntitlementsSlice = getBulkActionSlice(
    'unassignProductUserEntitlementsResult',
);

export const selectUnassignProductUserEntitlementsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.unassignProductUserEntitlementsResult.shown;

export const selectUnassignProductUserEntitlementsBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.unassignProductUserEntitlementsResult.uuid;

export const selectUnassignProductUserEntitlementsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.unassignProductUserEntitlementsResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = unassignProductUserEntitlementsSlice.actions;
